export default __webpack_public_path__ + "static/media/BeerPong.3be7a605.svg";